{
  "en": {
    "constants": {
      "address": {
        "city": "City",
        "country": "Country",
        "number": "Number",
        "street": "Street",
        "zip": "Post Code"
      },
      "crud": {
        "created_at": "Aangemaakt op",
        "deleted_at": "Verwijderd op",
        "updated_at": "Gewijzigd op"
      },
      "days": ["Su", "M", "Tu", "W", "Th", "F", "S"],
      "languages": {
        "de": "German",
        "en": "English",
        "fallback_info": "Seems like this message is not available in your language. We are using the existing {fallback_locale} translation instead.",
        "fr": "French",
        "nl": "Dutch",
        "pl": "Polish",
        "pt": "Portuguese"
      },
      "languages_short": {
        "de": "DE",
        "en": "EN",
        "fr": "FR",
        "nl": "NL",
        "pl": "PL",
        "pt": "PT"
      },
      "measurements": {
        "imperial": "Imperial",
        "metric": "Metric",
        "surface": {
          "imperial": "Sq. ft",
          "metric": "m²",
          "null": ""
        }
      },
      "months": [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      "profile_statuses": {
        "active": "Active",
        "added": "Not invited yet",
        "blocked": "Deactivated",
        "discarded": "Deleted",
        "invited": "Invited",
        "invited_at": "Invited"
      },
      "profile_statuses_descriptive": {
        "active": "Last time active on platform: {session_ended_at}",
        "added": "Not invited yet",
        "blocked": "Deactivated",
        "discarded": "Deleted",
        "invited": "Invited but hasn't signed up yet",
        "invited_at": "Invited {invited_at}. Not signed up yet"
      },
      "profile_titles": {
        "dr": "Dr",
        "mr": "Mr",
        "mrs": "Mrs",
        "professor": "Professor",
        "sirmadam": "-"
      },
      "time_units": {
        "days": "Days",
        "months": "Months",
        "weeks": "Weeks"
      },
      "time_units_count": {
        "days": "no day | day | days",
        "months": "no month | month | months",
        "weeks": "no week | week | weeks"
      },
      "timezones": {
        "America/Chicago": "America/Chicago",
        "America/Denver": "America/Denver",
        "America/Los_Angeles": "America/Los Angeles",
        "America/New_York": "America/New York",
        "Europe/Brussels": "Europe/Brussels",
        "Europe/Lisbon": "Europe/Lisbon",
        "Europe/London": "Europe/London",
        "Europe/Madrid": "Europe/Madrid"
      },
      "wind_orientations": {
        "east": "East",
        "north": "North",
        "northeast": "North East",
        "northwest": "North West",
        "select": "Select Orientation",
        "south": "South",
        "southeast": "South East",
        "southwest": "South West",
        "west": "West"
      }
    }
  }
}
